import { useState, useEffect } from 'react'
import { backendRequestAndNotification } from '../api'

const Deposits = ({ws}) => {
    const [invoices, setInvoices] = useState([])
    // eslint-disable-next-line
    const [realPage, setRealPage] = useState(0)

    useEffect(() => {
        async function getOffers() {
            try {
                const res = await fetch(process.env.REACT_APP_SERVER_URL + `/invoices/list/`, { credentials: 'include' });
                const data = await res.json();
            
                setInvoices(data)
            } catch (e) {
                setInvoices([])
                return
            }
        }
        
        getOffers()
    }, [realPage])

    function getStatusColor(status) {
        if (status === 'pending') return 'blue'
        if (status === 'expired') return 'red'
        if (status === 'confirmed') return 'green'
    }

    useEffect(() => {
        if (ws) {
          ws.on(`invoice_update`, (data) => {
                if (data.type === 'new') {
                    setInvoices([data.invoice, ...invoices])
                } else {
                    setInvoices(prevInvoices => {
                        let index = prevInvoices.findIndex(invoice => invoice._id === data._id)
                        if (index >= 0) {
                            let updatedInvoices = [...prevInvoices]
                            updatedInvoices[index] = data
                            return updatedInvoices
                        }
                        return prevInvoices
                    })
                }
            })
        }

        return () => {
            if (ws) {
                ws.off('invoice_update')
            }
        }
    }, [ws, invoices])


    return (
        <>

            <div className='orders-container'>
                <p className='title'>Deposits</p>

                <table>
                    <thead>
                        <tr className='blue'>
                            <th>Hash</th>
                            <th>Ad Tokens</th>
                            <th>Status</th>
                            <th>Date</th>
                            <th>Confirm Deposit</th>
                        </tr>
                    </thead>

                    <tbody>
                        {Array.isArray(invoices) && invoices.map((invoice, index) => (
                            <tr className='row' key={invoice._id}>
                                <td className='url'><a href={invoice.invoice_url} target='_blank' rel='noreferrer'>#{invoice.hash}</a></td>
                                <td>{invoice.amount}</td>
                                <td className={getStatusColor(invoice.status)}>{invoice.status}</td>
                                <td>{new Date(invoice.createdAt).toLocaleDateString()}</td>
                                {/* <td>{campaign.campaign_name}</td>
                                <td>{Number(campaign.campaign_cpv)*1000} ad tokens</td>
                                <td>{campaign.campaign_uses_remaining}</td>
                                <td>{campaign.campaign_uses_total}</td>
                                <td>{campaign.tokens_spent}</td>
                                <td className={getStatusColor(campaign.status)}>{(campaign.status)}</td>
                                <td>{new Date(campaign.campaign_created).toLocaleDateString()}</td> */}
                                <td>{invoice.status === 'pending' ? <button className='confirm' onClick={() => backendRequestAndNotification('/invoices/check', 'POST', {hash: invoice._id})}>Confirm</button> : <span>-</span>}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <style jsx>{`
                .orders-container {
                    width: 100%;

                    background-color: #141A31;
                    padding: 15px;
                }

                .confirm {
                    border: unset;
                    outline: unset;
                    color: white;
                    background-color: #4DAEFF;
                    border-radius: 6px;
                    cursor: pointer;
                    font-size: 12px;
                }

                .title {
                    text-align: center;
                    font-size: 20px;
                    font-weight: 600;
                    color: #F1C475;
                    margin: unset;
                }

                table {
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                }
                
                .url a {
                    color: #4DAEFF !important;
                    text-decoration: none;
                }

                tr {
                    width: 100%;
                    display: flex;
                    margin-top: 15px;
                    min-height: 30px;
                    height: 30px;
                    min-height: 30px;
                    border-radius: 6px;
                }

                td, th {
                    flex: 1;
                    text-align: center;
                    overflow-x: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                .row {
                    background-color: #21284C;
                    box-shadow: 0 3px 10px rgb(0 0 0 / 20%);
                }

                .green {
                    color: #4FAC7C;
                }

                .red {
                    color: #ac4f4f;
                }

                .blue {
                    color: #4F8DDE;
                }

                .clickable {
                    cursor: pointer;
                }

                .order-view {
                    height: 100%;
                    width: 100%;
                    background-color: rgba(0,0,0,0.5);

                    display: flex;
                    align-items: center;
                    justify-content: center;

                    position: fixed;

                    z-index: 1001;
                    top: 0;
                    left: 0;

                    animation: fadein .2s linear;
                }
                
                .order-center {
                    background-color: #21294D;

                    width: 500px;
                    height: 200px;
                    border-radius: 12px;
                    
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;

                    gap: 10px;
                }

                p {
                    margin: unset;
                }
                
                @keyframes fadein {
                    0% { opacity: 0; }
                    100% { opacity: 1; }
                }
            `}</style>
        </>
    )
}

export default Deposits